import { render, staticRenderFns } from "./litelist.vue?vue&type=template&id=2a8dc8d9&scoped=true"
import script from "./litelist.vue?vue&type=script&lang=js"
export * from "./litelist.vue?vue&type=script&lang=js"
import style0 from "./litelist.vue?vue&type=style&index=0&id=2a8dc8d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8dc8d9",
  null
  
)

export default component.exports